import { render, staticRenderFns } from "./YapiRuhsatTanimla.vue?vue&type=template&id=c6ae1768&"
import script from "./YapiRuhsatTanimla.vue?vue&type=script&lang=js&"
export * from "./YapiRuhsatTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports